import { memo } from "react";
import { ASSET_URLS, safeAssetIconName, type AssetImageKey } from "./asset-icon.constants";

export interface AssetIconProps {
    name: AssetImageKey;
    size?: number;
    className?: string;
}

function AssetIconComponent({ name, size = 24, className }: AssetIconProps) {
    const iconUrl = ASSET_URLS[safeAssetIconName(name)];
    return <img src={iconUrl} alt={String(name)} width={size} height={size} className={className} loading="lazy" />;
}

export const AssetIcon = memo(AssetIconComponent);
